import React, { useEffect } from 'react';
import AnimateHeight from 'react-animate-height';
import Div from '../Element/Div/Div';
import styles from './Drawer.module.scss';
import usePreventScroll from '../../shared/utils/usePreventScroll/usePreventScroll';
import { CommonProps } from '../Element/Element';
import Backdrop from '../Backdrop/Backdrop';

type DrawerProps = {
  /** Is Drawer open */
  isOpen?: boolean;
  /** Is showing backdrop */
  showBackdrop?: boolean;
  /** The event when Backdrop is clicked */
  onCloseClick?: () => void;
  /** Use automatic scroll prevention */
  automaticScrollPrevention?: boolean;
} & CommonProps<'div'>;

export const Drawer: React.FunctionComponent<DrawerProps> = ({
  isOpen = false,
  onCloseClick,
  children,
  showBackdrop = true,
  automaticScrollPrevention = true,
  ...props
}) => {
  if (automaticScrollPrevention) {
    usePreventScroll(isOpen && showBackdrop);
  }

  useEffect(() => {
    const closeKeyHandler = ({ key }: KeyboardEvent) => {
      if (key === 'Escape') {
        onCloseClick?.();
      }
    };

    document.addEventListener('keydown', closeKeyHandler);

    return () => {
      document.removeEventListener('keydown', closeKeyHandler);
    };
  });

  return (
    <>
      <Div className={[styles.drawer]}>
        <AnimateHeight duration={250} height={isOpen ? 'auto' : 0}>
          <Div {...props}>{children}</Div>
        </AnimateHeight>
      </Div>

      <Backdrop
        isVisible={showBackdrop && isOpen}
        onCloseClick={onCloseClick}
      />
    </>
  );
};

export default Drawer;
